import { Fragment, useState } from 'react';
import styled from '@emotion/styled';
import { ConditionalPropResponse, Episode } from '../../apiService';
import EpisodeItem from './EpisodeItem';
import { Divider, Row } from '../../styles';
import PageOverlay from '../../styles/PageOverlay';

export default function EpisodeList({ episodes = [], reactions }: EpisodeListProps) {
  const [activeCardId, setActiveCardId] = useState<string | null>(null);
  return (
    <>
      <PageOverlay visible={!!activeCardId} />
      <EpisodeRow cols={{ xs: 1, sm: 2, md: 4, xl: 5 }}>
        {!!episodes?.length &&
        episodes.map((episode, index) => {
          const id = episode.id ?? episode.short_id ?? `${index}`;
          const active = id === activeCardId;
          return (
            <Fragment key={id}>
              <EpisodeWrapper data-active={active ? 'true' : 'false'}>
                <EpisodeItem
                  {...episode}
                  flags={getFlags(episode.id, reactions)}
                  active={active}
                  onHoverChange={setActiveCardId}
                />
              </EpisodeWrapper>
              <Divider className="mobile-only" mt=".75rem" />
            </Fragment>
          );
        })}
      </EpisodeRow>
    </>
  );
}

const getFlags = (id: string, reactions: EpisodeListProps['reactions']) => reactions?.[id]?.conditional_flag;

const EpisodeRow = styled(Row)(() => ({
  '> li': {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    zIndex: 1,
  },
  '> li:hover, > li:has([data-active="true"])': {
    zIndex: 9999,
  },
  '> li > div:first-of-type': {
    width: '100%',
    flex: 1,
  },
}));

const EpisodeWrapper = styled.div(() => ({
  position: 'relative',
}));

interface EpisodeListProps {
  episodes?: Episode[];
  reactions?: Record<string, Pick<ConditionalPropResponse, 'conditional_flag'>>;
}
